import React, { useState } from 'react';
import AddHouseholdModal from './AddHouseholdForm';
import HouseholdList from './HouseholdList';
import PendingInvitations from './PendingInvitations';
import { PlusIcon } from '@heroicons/react/20/solid';
import { Button } from './ui';

export const HouseholdsPage: React.FC = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <>
      <div className="flex justify-between items-center gap-4 mb-6">
        <h2 className="text-xl font-bold tracking-tight text-gray-900 dark:text-gray-100">Households</h2>
        <Button variant="primary" icon={PlusIcon} onClick={() => setIsAddModalOpen(true)}>
          Add Household
        </Button>
      </div>

      <PendingInvitations />

      <HouseholdList onAddHousehold={() => setIsAddModalOpen(true)} />

      <AddHouseholdModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
      />
    </>
  );
};